import React, {
  useEffect,
  useState,
  useCallback,
  useContext,
  useRef,
} from "react";
import HeadingBanner from "../Components/HeadingBanner.jsx";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  contactsave,
  postSchemaSave,
  postTranscationSave,
} from "../api/Pageapi.js";
import toast from "react-hot-toast";
import AOS from "aos";
import { useRazorpay } from "react-razorpay";
import { Logindetail } from "../context/Logindetail.js";
import { useLocation, useNavigate } from "react-router-dom";
import { Savedigitalplan } from "../api/RouteScheme2.js";
import { SaveGoldplan } from "../api/RouteScheme3.js";
import { set } from "date-fns";
import axios from "axios";
import Select from "react-select";
import {
  Arrow90degLeft,
  ArrowLeft,
  ArrowUp,
  ArrowUpShort,
  ChevronDown,
  X,
} from "react-bootstrap-icons";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import instance from "../Config/Config.js";
import { setCount } from "../store/slices/counterSlice.jsx";
import { useDispatch } from "react-redux";
import { RazarDetails } from "../context/razarApi.js";
import { apply_coupon, capture_payment } from "../api/Controllapi.js";
import { Modal, Button } from "react-bootstrap";
import { Snackbar, Alert } from "@mui/material";
import { FaCopy } from "react-icons/fa";




const CheckOutFormPage = ({ setting_data }) => {
  const [spinner, setspinner] = useState(false);
  const location = useLocation();
  const { token, detail_info, setdetail_info } = useContext(Logindetail);
  const totalPrice = location.state?.total;



  // .......................

  //default key
  // const RAZAR_KEY = "rzp_live_FZ6iVw5tcRGpW5";
  const router = useNavigate();
  const [shemData, setSchemaData] = useState("product_check");
  const [process_type, setprocess_type] = useState("1");
  const { error, isLoading: isRazorpayLoading, Razorpay } = useRazorpay();
  const [showRazorpayModal, setShowRazorpayModal] = useState(false);
  const [file1, setfile1] = useState();
  const [Transactionid, setTranscationid] = useState();
  const [transfile, settransfile] = useState();

  const [benificid, setbenificid] = useState("");

  const [price, setprice] = useState();
  const [ChargeAmt, setChargeAmt] = useState();
  const [Benifitid, setBenifitid] = useState();
  const [isloading, setIsloading] = useState(true);

  const [totapricedata, setTotalPriceData] = useState();
  const [cartdata, setCartData] = useState([]);
  const [clientamount, setclientamount] = useState(0);
  const [special_discount, setSpecialDiscount] = useState(0);

  //added for wallet
  // const [walletAmount, setWalletAmount] = useState()
  // const [applywallet, setApplyWallet] = useState(false)
  // const [finalPrice, setFinalPrice] = useState(0)



  // coupon
  // ==== STATE VARIABLES ====
  const [totalAmount, setTotalAmount] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);
  const [shippingAmount, setShippingAmount] = useState(0);
  const [walletAmount, setWalletAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountType, setDiscountType] = useState("");
  const [finalPrice, setFinalPrice] = useState(0);
  const [grandTotalAmount, setGrandTotalAmount] = useState(0);
  const [walletUsedAmount, setWalletUsedAmount] = useState();
  const [remainingWallet, setRemainingWallet] = useState(0);
  const [applyWallet, setApplyWallet] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponInfo, setCouponInfo] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [couponMessage, setCouponMessage] = useState("");
  const [walletApivalue, setWalletApiValue] = useState(0)





  const [new_razar_key, setNew_razar_key] = useState(() => {

    return localStorage.getItem("razorpay_key") || "";
  });

  const fetchKey = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}razorpay_key`
      );

      const apiKey = response?.data?.razorpay_key;

      if (!apiKey) {
        throw new Error("Invalid response format");
      }

      const storedKey = localStorage.getItem("razorpay_key");


      if (!storedKey) {
        localStorage.setItem("razorpay_key", apiKey);
        setNew_razar_key(apiKey);
        return;
      }


      if (storedKey !== apiKey) {
        localStorage.setItem("razorpay_key", apiKey);
        setNew_razar_key(apiKey);
        return;
      }


      setNew_razar_key(storedKey);

    } catch (error) {
      console.error("Failed to fetch Razorpay key:", error);
    }
  };

  useEffect(() => {
    fetchKey();
  }, []);






  //addded key
  //  const {new_razar_key} = useContext(RazarDetails)

  //  const new_razar_key = localStorage.getItem('razorpay_key');
  const RAZAR_KEY = new_razar_key;


  // console.log(clientamount, "amount...................")



  // console.log("totapricedata", totapricedata);
  const GetCartListfirst = async () => {
    try {
      const responseApi = await instance.get(`get_cart_list`);
      const itemCount = responseApi?.data?.carts?.length || 0;
      setTotalPriceData(responseApi.data);
      setclientamount(responseApi?.data?.grand_total);

    } catch (error) {
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );
    }
  };
  const handleCouponSelect = (selectedCode) => {
    setTotalPriceData((prev) => ({
      ...prev,
      coupon_code: selectedCode,
    }));
    // optionally call your API to revalidate or reapply coupon
  };


  // const [isCouponApplied, setIsCouponApplied] = useState(false);
  const GetCheckoutList = async () => {
    setIsloading(true);
    try {
      const responseApi = await instance.get(`checkout`);
      setTotalPriceData(responseApi.data);

      //added
      // setOriginalTotal(responseApi?.data.grand_total)
      setFinalPrice(Number(responseApi?.data.grand_total).toFixed(2));

      setWalletAmount(responseApi?.data?.wallet)
      // setWalletAmount(2000)
      setTotalAmount(totapricedata?.total)
      setWalletApiValue(responseApi?.data?.wallet || 0);
      // console.log(totapricedata?.total)

      setclientamount(responseApi?.data?.grand_total);
      setCoupon_data(responseApi?.data?.coupon)

      const checkCoupon = responseApi?.data?.carts?.some(
        (item) => item.coupon_applied === 1
      );
      // setIsCouponApplied(checkCoupon);

      setCartData(responseApi?.data?.carts);
      setIsloading(false);
    } catch (error) {
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );
      setIsloading(true);
    }
  };

  useEffect(() => {
    // GetCartListfirst();
    if (token && detail_info) {
      GetCheckoutList();
    }
  }, []);

  const paymentfun = (e) => {
    e.preventDefault();

    if (process_type == "1") {
      setSchemaData("saving_plan");
      setShowRazorpayModal(true);
      handlepayModal();
      document.getElementById("payment-pup").click();
      //  document.getElementById('Rupees').value = null
    } else if (process_type == "2") {
      document.getElementById("payment-pup").click();
      document.getElementById("offlinepop-pup").click();
      document.getElementById("transaction-id").value = null;
      setfile1();
      settransfile();
      setTranscationid();
    } else if (process_type == "3") {
      document.getElementById("payment-pup").click();
      document.getElementById("bankpop-pup").click();
      document.getElementById("transaction-id2").value = null;
      setTranscationid();
    } else {
      toast.error("please select payment method");
    }
  };

  const initvalue = {
    // name: detail_info?.name,
    // email: detail_info?.email,
    // phone_no: detail_info?.phone_number,
    // city: "",
    // requirement: "",
    address: "",
  };
  const updateschema = Yup.object().shape({
    // name: Yup.string()
    //   .required("Enter Your  Name")
    //   .matches(/^([^0-9]*)$/, "Invalid name"),
    // city: Yup.string()
    //   .required("Enter Your City")
    //   .matches(/^[a-zA-Z ]*$/, "Invalid name"),
    // email: Yup.string()
    //   .email("InValid Email")
    //   .required("Enter Your Email")
    //   .matches(
    //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/,
    //     "Invalid Email"
    //   )
    //   .test("Invalid Email", (value) => {
    //     return value === value.toLowerCase();
    //   }),
    // phone_no: Yup.string()
    //   .min(10, "Phone Number Minimum 10 digits")
    //   .max(10, "Phone Number Maximum 10 digits")
    //   .required("Enter Your Phone Number")
    //   .matches(/^[0-9]+$/, "Invalid  Phone Number"),

    address: Yup.string().required("Address is required"),
  });

  const Formik = useFormik({
    initialValues: initvalue,
    validationSchema: updateschema,

    onSubmit: async (value, { setErrors, resetForm }) => {
      // document.getElementById("payment-pup").click();

      setShowRazorpayModal(true);
      handlepayModal();

      // setspinner(true)
      // await contactsave(value)
      //   .then((res) => {
      //     toast.success(res?.message)
      //     resetForm()
      //     setspinner(false)
      //   })
      //   .catch((err) => {
      //     if (err?.response?.status == "400") {
      //       toast.error(err?.response?.data?.email)
      //     }
      //     setspinner(false)
      //   })
    },
  });

  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);

  //   const paymentfun = (e) => {
  //   e.preventDefault();

  //   switch (process_type) {
  //     case "1":
  //       setSchemaData("saving_plan"); // set to string
  //       setShowRazorpayModal(true);
  //       handlepayModal("saving_plan"); // pass string explicitly

  //       const razorBtn = document.getElementById('payment-pup');
  //       if (razorBtn) razorBtn.click();

  //       break;

  //     case "2":
  //       document.getElementById('payment-pup')?.click();
  //       document.getElementById('offlinepop-pup')?.click();
  //       const txnIdEl = document.getElementById('transaction-id');
  //       if (txnIdEl) txnIdEl.value = null;

  //       setfile1(null);
  //       settransfile(null);
  //       setTranscationid(null);

  //       break;

  //     case "3":
  //       document.getElementById('payment-pup')?.click();
  //       document.getElementById('bankpop-pup')?.click();
  //       const txnId2El = document.getElementById('transaction-id2');
  //       if (txnId2El) txnId2El.value = null;

  //       setTranscationid(null);
  //       break;

  //     default:
  //       toast.error('Please select a payment method');
  //   }
  // };


  // 1 plan
  //   const handlePayment = useCallback(async (price) => {


  //     //  const order = await instance.orders.create({
  //     //     amount: ChargeAmt * 100,
  //     //     currency: "INR",
  //     //     receipt: "rcptid_11",
  //     //     payment_capture: 1, // Automatically capture payment
  //     //     payment: {
  //     //       capture_options: {
  //     //         automatic_expiry_period: 12,
  //     //         manual_expiry_period: 7200,
  //     //         refund_speed: "optimum",
  //     //       },
  //     //     },
  //     //   });

  // console.log(price,"ccc")

  //     const options = {
  //       key: RAZAR_KEY,

  //       amount: clientamount * 100,//removed * 100
  //       currency: "INR",
  //       name: "Greenheap",
  //       description: "Greenheap",
  //       image: "/assets/iocns/__Fav Icon.png",
  //       // order_id: order.id,
  //       handler: (res) => {
  //         const transactionId = res.razorpay_payment_id;
  //         const body = {
  //           amount: clientamount,
  //           // saving_plan_id: shemData?.id,
  //           transaction_id: res?.razorpay_payment_id,
  //           // benificiar: benificid,
  //           payment_method: "razor_pay",
  //           transaction_status: "success",
  //         };

  //           const walletBody = {
  //             order_from: "web",
  //             address_id: addressWalletId,
  //             payment_method: "razor_pay",
  //             transaction_status: "success",
  //           };


  //           if (walletUsedAmount && walletUsedAmount > 0) {
  //             walletBody.wallet = walletUsedAmount;
  //           }

  //           if (discountAmount && discountAmount > 0) {
  //             walletBody.discount = discountAmount;
  //           }


  //           if (couponCode && couponCode.trim().length > 0) {
  //             walletBody.coupon_code = couponCode.trim();
  //           }

  //         postTranscationSave(walletBody, token)
  //           .then((res) => {
  //             if (res?.error) {
  //               return toast.error(res?.error ?? "Somthing Went Wrong!");
  //             }
  //             router("/user/dashboard");
  //             dispatch(setCount(0));
  //             toast.success(`Payment successful `);
  //             setShowRazorpayModal(false);

  //             let resBody = {
  //               "paymentId": transactionId,
  //               "amount": clientamount
  //             }

  //             capture_payment(resBody)
  //               .then((res) => {
  //                 // console.log(res)
  //                 console.log("done")
  //               })
  //               .catch((e) => {
  //                 console.log(e)
  //               })


  //           })
  //           .catch((err) => {
  //             console.log("err", err.message);
  //           });
  //       },
  //       theme: {
  //         color: "#650020",
  //       },
  //       payment: {
  //         capture: 'automatic',
  //         capture_options: {
  //           automatic_expiry_period: 12,
  //           manual_expiry_period: 7200,
  //           refund_speed: 'optimum'
  //         }
  //       }
  //     };

  //     const rzpay = new Razorpay(options);

  //     rzpay.open();

  //     // Reset the showRazorpayModal state after payment completion

  //     rzpay.on("payment.failed", function (response) {
  //       setShowRazorpayModal(false);
  //       console.log("fail");
  //       console.error(response.error.description);
  //       toast.error(response.error.description);
  //     });
  //   }, [price, shemData, clientamount]);

  const handlepayModal = () => {
    if (shemData === "saving_plan") {
      handlePayment();
    }
    if (shemData?.plan_title === "digital_plan") {
      handlePaymentDigital();
    }
    if (shemData?.plan_title === "gold_plant") {
      handlePaymentgoldplant();
    }
  };

  // const testKey = "rzp_test_K7CipNQYyyMPiS";
  const dispatch = useDispatch();

  // 2 plan
  const handlePaymentDigital = useCallback(async () => {

    // console.log("handlePaymentDigital")


    const options = {
      key: RAZAR_KEY,
      amount: Math.round(clientamount * 100),
      currency: "INR",
      name: "Greenheap",
      description: "Greenheap",
      image: "/assets/iocns/__Fav Icon.png",
      handler: (res) => {

        const transactionId = res.razorpay_payment_id;

        const body = {
          digital_plan_id: shemData?.id,
          amount: clientamount,
          transaction_id: res?.razorpay_payment_id,
          // 'benificiar': benificid,
          payment_method: "razor_pay",
        };
        Savedigitalplan(body)
          .then((res) => {
            if (res?.error) {
              return toast.error(res?.error ?? "Somthing Went Wrong!");
            }
            router("/user/myorders");
            toast.success(`Payment successful from ${shemData?.name}`);
            setShowRazorpayModal(false);

            let resBody = {
              "paymentId": transactionId,
              "amount": clientamount
            }

            capture_payment(resBody)
              .then((res) => {
                // console.log(res)
                // console.log("done")
              })
              .catch((e) => {
              })


          })
          .catch((err) => {
          });
      },
      theme: {
        color: "#650020",
      },
      payment: {
        capture: 'automatic',
        capture_options: {
          automatic_expiry_period: 12,
          manual_expiry_period: 7200,
          refund_speed: 'optimum'
        }
      }
    };

    const rzpay = new Razorpay(options);

    rzpay.open();

    // Reset the showRazorpayModal state after payment completion
    rzpay.on("payment.failed", function (response) {
      setShowRazorpayModal(false);
      console.error(response.error.description);
      toast.error(response.error.description);
    });
  }, [price, shemData]);

  // 3 plan
  const handlePaymentgoldplant = useCallback(async () => {
    // const order = await instance.orders.create({
    //   amount: ChargeAmt * 100,
    //   currency: "INR",
    //   receipt: "rcptid_11",
    //   payment_capture: 1, // Automatically capture payment
    //   payment: {
    //     capture_options: {
    //       automatic_expiry_period: 12,
    //       manual_expiry_period: 7200,
    //       refund_speed: "optimum",
    //     },
    //   },
    // });

    // console.log("handlePaymentgoldplant")

    const options = {
      key: RAZAR_KEY,
      amount: Math.round(ChargeAmt * 100),
      currency: "INR",
      name: "Greenheap",
      description: "Greenheap",
      // order_id: order.id,
      image: "/assets/iocns/__Fav Icon.png",
      handler: (res) => {

        const transactionId = res.razorpay_payment_id;
        const clientamount = ChargeAmt

        const body = {
          gold_plant_id: shemData?.id,
          amount: ChargeAmt,
          transaction_id: res?.razorpay_payment_id,
          benificiar: Benifitid,
          payment_method: "razor_pay",
        };
        SaveGoldplan(body)
          .then((res) => {
            if (res?.error) {
              return toast.error(res?.error ?? "Somthing Went Wrong!");
            }
            router("/user/myorders");
            toast.success(`Payment successful from ${shemData?.name}`);
            setShowRazorpayModal(false);
            setbenificid();

            let resBody = {
              "paymentId": transactionId,
              "amount": clientamount
            }

            capture_payment(resBody)
              .then((res) => {
                // console.log(res)
                // console.log("done")
              })
              .catch((e) => {
              })


          })
          .catch((err) => {
          });
      },
      theme: {
        color: "#650020",
      },
      payment: {
        capture: 'automatic',
        capture_options: {
          automatic_expiry_period: 12,
          manual_expiry_period: 7200,
          refund_speed: 'optimum'
        }
      }
    };

    const rzpay = new Razorpay(options);

    rzpay.open();

    // Reset the showRazorpayModal state after payment completion
    rzpay.on("payment.failed", function (response) {
      setShowRazorpayModal(false);
      console.error(response.error.description);
      toast.error(response.error.description);
    });
  }, [ChargeAmt, shemData]);

  // upi method second payment method........
  const upimethod = (e) => {
    e.preventDefault();
    if (!transfile) {
      toast.error("please Upload the transaction slip");
      return false;
    }
    if (shemData?.plan_title === "saving_plan") {
      if (Transactionid || transfile) {
        setspinner(true);

        const formdata = new FormData();
        formdata.append("amount", clientamount);
        formdata.append("saving_plan_id", shemData?.id);
        formdata.append(
          "transaction_id",
          Transactionid ? Transactionid : null
        );
        formdata.append("benificiar", benificid);
        formdata.append("payment_method", "upi");
        formdata.append("uploads", transfile);
        postSchemaSave(formdata)
          .then((res) => {
            if (res?.error) {
              return toast.error(res?.error ?? "Somthing Went Wrong!");
            }
            setspinner(false);
            // toast.success(`Payment successful from ${shemData?.name}`);
            toast.success('Transaction submitted successfully. Please wait for admin approval')
            document.getElementById("offlinepop-pup").click();
            router("/user/myorders");
            setShowRazorpayModal(false);
          })
          .catch((err) => {
          });
      } else {
        toast.error(
          "please Upload the transaction slip or enter the transaction ID"
        );
      }
    }

    if (shemData?.plan_title === "digital_plan") {
      if (Transactionid || transfile) {
        setspinner(true);
        const formdata = new FormData();
        formdata.append("amount", clientamount);
        formdata.append("digital_plan_id", shemData?.id);
        formdata.append(
          "transaction_id",
          Transactionid ? Transactionid : null
        );
        formdata.append("benificiar", benificid);
        formdata.append("payment_method", "upi");
        formdata.append("uploads", transfile);

        Savedigitalplan(formdata)
          .then((res) => {
            if (res?.error) {
              return toast.error(res?.error ?? "Somthing Went Wrong!");
            }
            // toast.success(`Payment successful from ${shemData?.name}`);
            toast.success('Transaction submitted successfully. Please wait for admin approval')

            document.getElementById("offlinepop-pup").click();
            router("/user/myorders");
            setShowRazorpayModal(false);
            setspinner(false);
          })
          .catch((err) => {
          });
      } else {
        toast.error(
          "please Upload the transaction slip or enter the transaction ID"
        );
      }
    }

    if (shemData?.plan_title === "gold_plant") {
      if (Transactionid || transfile) {
        setspinner(true);

        const formdata = new FormData();
        formdata.append("amount", clientamount);
        formdata.append("gold_plant_id", shemData?.id);
        formdata.append(
          "transaction_id",
          Transactionid ? Transactionid : null
        );
        formdata.append("benificiar", benificid);
        formdata.append("payment_method", "upi");
        formdata.append("uploads", transfile);

        SaveGoldplan(formdata)
          .then((res) => {
            if (res?.error) {
              return toast.error(res?.error ?? "Somthing Went Wrong!");
            }
            // toast.success(`Payment successful from ${shemData?.name}`);
            toast.success('Transaction submitted successfully. Please wait for admin approval')

            document.getElementById("offlinepop-pup").click();
            router("/user/myorders");
            setShowRazorpayModal(false);
            setspinner(false);
          })
          .catch((err) => {
          });
      } else {
        toast.error(
          "please Upload the transaction slip or enter the transaction ID"
        );
      }
    }
  };

  const screenshot = (e) => {
    setfile1(e.target.files[0]?.name);
    settransfile(e.target.files[0]);
  };

  // Bankmethod method Third payment method........

  const Bankmethod = (e) => {
    e.preventDefault();

    if (!transfile) {
      toast.error("please Upload the transaction slip");
      return false;
    }

    if (shemData?.plan_title === "saving_plan") {
      if (Transactionid || transfile) {
        setspinner(true);

        const formdata = new FormData();
        formdata.append("amount", clientamount);
        formdata.append("saving_plan_id", shemData?.id);
        formdata.append(
          "transaction_id",
          Transactionid ? Transactionid : null
        );
        formdata.append("benificiar", benificid);
        formdata.append("payment_method", "bank");
        formdata.append("uploads", transfile);

        postSchemaSave(formdata)
          .then((res) => {
            if (res?.error) {
              return toast.error(res?.error ?? "Somthing Went Wrong!");
            }
            // toast.success(`Payment successful from ${shemData?.name}`);
            toast.success('Transaction submitted successfully. Please wait for admin approval')

            document.getElementById("bankpop-pup").click();
            router("/user/myorders");
            setShowRazorpayModal(false);
            setspinner(false);
          })
          .catch((err) => {
          });
      } else {
        toast.error(
          "please Upload the transaction slip or enter the transaction ID"
        );
      }
    }
    if (shemData?.plan_title === "digital_plan") {
      if (Transactionid || transfile) {
        setspinner(true);

        const formdata = new FormData();
        formdata.append("amount", clientamount);
        formdata.append("digital_plan_id", shemData?.id);
        formdata.append(
          "transaction_id",
          Transactionid ? Transactionid : null
        );
        formdata.append("benificiar", benificid);
        formdata.append("payment_method", "bank");
        formdata.append("uploads", transfile);

        Savedigitalplan(formdata)
          .then((res) => {
            if (res?.error) {
              return toast.error(res?.error ?? "Somthing Went Wrong!");
            }
            // toast.success(`Payment successful from ${shemData?.name}`);
            toast.success('Transaction submitted successfully. Please wait for admin approval')
            document.getElementById("bankpop-pup").click();
            router("/user/myorders");
            setShowRazorpayModal(false);
            setspinner(false);
          })
          .catch((err) => {
          });
      } else {
        toast.error(
          "please Upload the transaction slip or enter the transaction ID"
        );
      }
    }
    if (shemData?.plan_title === "gold_plant") {
      if (Transactionid || transfile) {
        setspinner(true);
        const formdata = new FormData();
        formdata.append("amount", clientamount);
        formdata.append("gold_plant_id", shemData?.id);
        formdata.append(
          "transaction_id",
          Transactionid ? Transactionid : null
        );
        formdata.append("benificiar", benificid);
        formdata.append("payment_method", "bank");
        formdata.append("uploads", transfile);
        SaveGoldplan(formdata)
          .then((res) => {
            if (res?.error) {
              return toast.error(res?.error ?? "Somthing Went Wrong!");
            }
            // toast.success(`Payment successful from ${shemData?.name}`);
            toast.success('Transaction submitted successfully. Please wait for admin approval')
            document.getElementById("bankpop-pup").click();
            router("/user/myorders");
            setShowRazorpayModal(false);
            setspinner(false);
          })
          .catch((err) => {
          });
      } else {
        toast.error(
          "please Upload the transaction slip or enter the transaction ID"
        );
      }
    }
  };

  const [addressType, setAddressType] = useState("existing");
  const navigate = useNavigate();
  const [AddressList, setAddressList] = useState([]);

  // const fetchAddress = async () => {
  //   try {
  //     const responseApi = await instance.get("address");
  //     console.log("responseApi", responseApi?.data?.data);
  //     setAddressList(responseApi?.data?.data || []);

  //     const checkdefault = responseApi?.data?.data?.find(
  //       (address) => address.set_default === 1
  //     );

  //     const label = `${checkdefault.address_line_1 || ""} ${
  //       checkdefault.address_line_2 || ""
  //     } ${checkdefault.city?.city || ""}, ${checkdefault.state?.state || ""} ${
  //       checkdefault.country?.name || ""
  //     } - ${checkdefault.postal_code || ""}`;

  //     if (checkdefault) {
  //       setIsAccordionOpen(false);
  //       setSelectedLabel(label);
  //     }

  //   } catch (err) {
  //     console.error("Failed to fetch countries:", err);
  //   }
  // };

  const fetchAddress = async () => {
    try {
      const responseApi = await instance.get("address");
      // Set the address list
      setAddressList(responseApi?.data?.data || []);
      // Find the default address
      const checkdefault = responseApi?.data?.data?.find(
        (address) => address.set_default === 1
      );

      if (checkdefault) {
        // Construct the label for the default address
        const label = `${checkdefault.address_line_1 || ""} ${checkdefault.address_line_2 || ""
          } ${checkdefault.city?.city || ""}, ${checkdefault.state?.state || ""
          } ${checkdefault.country?.name || ""} - ${checkdefault.postal_code || ""
          }`;
        Formik.setFieldValue("address", checkdefault.id);
        // Update states
        setIsAccordionOpen(false);
        setAddressWalletId(checkdefault.id)
        // console.log(label, checkdefault.id, 'nine') // Close the accordion
        setSelectedLabel(label); // Set the label of the selected default address
      } else {
        // Optionally handle the case where no default address is found
        setSelectedLabel(null); // Clear selected label if no default address
      }
    } catch (err) {
      console.error("Failed to fetch addresses:", err);
    }
  };

  useEffect(() => {
    fetchAddress();
  }, []);

  const [selectedAddress, setSelectedAddress] = useState(null);

  const addressOptions = [
    {
      id: 1,
      label: "123 Main St, Apt 4B, New York, NY, USA",
    },
    {
      id: 2,
      label: "456 Elm St, Suite 2A, San Francisco, CA, USA",
    },
  ];
  const sampleImageWithNamePrice = [
    {
      id: 1,
      name: "Gh 1 Gram Gold ",
      price: "₹ 50000.32",
      image: "https://admin.greenheapgold.com/public/product/1726897514_1.png",
    },
    {
      id: 2,
      name: "22 gram girls silver",
      price: "₹ 500.36",
      image: "https://admin.greenheapgold.com/public/product/1726897539_6.png",
    },
    {
      id: 3,
      name: "Gh 1 Gram Coin 24k ",
      price: "₹ 6543121.00",
      image: "https://admin.greenheapgold.com/public/product/1726922591_5.png",
    },
    // {
    //   id: 4,
    //   name: "Product 2",
    //   price: "$15.99",
    //   image: "https://admin.greenheapfoods.in/storage/app/public/product/2025-01-03-67778a7d1e5fd.png"
    // },
    // {
    //   id: 4,
    //   name: "Product 2",
    //   price: "$15.99",
    //   image: "https://admin.greenheapfoods.in/storage/app/public/product/2025-01-03-67778a7d1e5fd.png"
    // }
  ];
  const [addressWalletId, setAddressWalletId] = useState()
  const [selectedLabel, setSelectedLabel] = useState("");
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const handleAddressChange = async (addressId, label) => {
    try {
      const response = await instance.post("address/default", {
        id: addressId,
      });
      // setAddressWalletId(addressId)
      // console.log(addressWalletId, "wallet")

      Formik.setFieldValue("address", addressId);
      setSelectedLabel(label);
      // console.log("changed.......",label)
      setIsAccordionOpen(false);
    } catch (error) {
      console.error("Error during API call:", error);
      // Handle error (you can show a message to the user, log the error, etc.)
    }
  };

  // const handleClick = () => {

  //   navigate("/FillForm");
  // };
  // console.log(addressWalletId, 'wallet id')
  const handleClick = (type) => {
    navigate("/FillForm", {
      state: { type: type },
    });
  };

  // Handle editing an address
  const handleEditAddress = (addressId) => {
    // console.log("Edit Address ID: ", addressId);
  };
  // Handle deleting an address
  const handleDeleteAddress = async (addressId) => {
    try {
      const response = await instance.get(`address/delete/${addressId}`);
      fetchAddress();
      setSelectedLabel("");
    } catch (error) {
      console.error("Error during address delete:", error);
    }
  };
  // const [couponCode, setCouponCode] = useState("");
  const [discountedAmount, setDiscountedAmount] = useState(null);
  // const [couponMessage, setCouponMessage] = useState("");
  const [coupon_data, setCoupon_data] = useState([])
  // const [wallet,set]
  const calculateTotals = (manualDiscount) => {
    const subtotal = Number(totapricedata?.total) || 0;
    const gst = Number(totapricedata?.gst) || 0;
    const shipping = Number(totapricedata?.shipping_cost) || 0;
    // Use manual discount if provided (from apply/remove)
    const discount = manualDiscount !== undefined
      ? Number(manualDiscount)
      : Number(discountAmount) || 0;

    let finalTotal = subtotal + gst + shipping - discount;
    if (finalTotal < 0) finalTotal = 0;
    finalTotal = Number(finalTotal.toFixed(2));

    setFinalPrice(finalTotal);
    setGrandTotalAmount(finalTotal);
    // console.log("===== 🧾 CALCULATE TOTALS =====");
    // console.log("Subtotal      :", subtotal);
    // console.log("GST           :", gst);
    // console.log("Shipping      :", shipping);
    // console.log("Discount      :", discount, `(${discountType})`);
    // console.log("➡️ Grand Total :", finalTotal);
    // console.log("=================================\n");
    // Apply wallet logic if active
    if (applyWallet) {
      updateWalletCalculation(finalTotal);
    }
  };
  const updateWalletCalculation = (orderAmount) => {
    const walletBalance = Number(walletAmount) || 0;
    const discount = Number(discountAmount) || 0;
    let usedWallet = 0;
    let remaining = walletBalance;
    let payable = orderAmount;
    if (applyWallet) {
      if (walletBalance >= orderAmount) {
        usedWallet = orderAmount;
        payable = 0;
        remaining = walletBalance - orderAmount;
      } else {
        usedWallet = walletBalance;
        payable = orderAmount - walletBalance;
        remaining = 0;
      }
    }
    usedWallet = Number(usedWallet.toFixed(2));
    remaining = Number(remaining.toFixed(2));
    payable = Number(payable.toFixed(2));
    setWalletUsedAmount(usedWallet);
    setRemainingWallet(remaining);
    setFinalPrice(payable);
    setGrandTotalAmount(payable);
    // console.log("===== 💰 WALLET CALCULATION =====");
    // console.log("Wallet Balance   :", walletBalance);
    // console.log("Discount Applied :", discount);
    // console.log("Order Amount     :", orderAmount);
    // console.log("Used Wallet      :", usedWallet);
    // console.log("Remaining Wallet :", remaining);
    // console.log("Payable Amount   :", payable);
    // console.log("=================================");
  };


  const handleApplyCoupon = async () => {
    if (applyWallet && Number(finalPrice) === 0 && !couponApplied) {
      toast.error("Coupon not applicable when wallet covers the full amount.");
      return;
    }

    if (!couponCode.trim()) {
      setCouponMessage("Please enter a coupon code.");
      return;
    }

    try {
      const response = await instance.get("/add_coupon", {
        params: { coupon_code: couponCode.trim() },
      });

      const data = response.data;

      if (data && data.coupon) {
        const coupon = data.coupon;
        const subtotal = Number(totapricedata?.total) || 0;

        let discount = Number(coupon.discount) || 0;
        let discountTypeValue = coupon.discount_type || "amount";

        // Parse details (min_buy, max_discount)
        let minBuy = 0;
        let maxDiscount = 0;
        if (coupon.details) {
          try {
            const details = JSON.parse(coupon.details);
            minBuy = Number(details.min_buy) || 0;
            maxDiscount = Number(details.max_discount) || 0;
          } catch (err) {
            console.error("Error parsing coupon details:", err);
          }
        }

        if (subtotal < minBuy) {
          setCouponApplied(false);
          setDiscountAmount(0);
          toast.error(`Coupon applicable only for orders above ₹${minBuy}`);
          return;
        }

        let discountValue = 0;
        if (discountTypeValue === "amount") {
          discountValue = discount;
        } else if (discountTypeValue === "percent") {
          discountValue = (subtotal * discount) / 100;
        }

        if (maxDiscount > 0 && discountValue > maxDiscount) {
          discountValue = maxDiscount;
        }

        setCouponApplied(true);
        setDiscountAmount(discountValue);
        setDiscountType(discountTypeValue);
        setCouponInfo({
          code: coupon.code,
          discount,
          discountType: discountTypeValue,
          maxDiscount,
          minBuy,
        });

        toast.success(data.message || "Coupon applied successfully!");
        setCouponMessage("Coupon applied successfully!");

        // Recalculate totals with discount
        calculateTotals(discountValue);
      } else {
        toast.error(data.message || "Invalid coupon code.");
        setCouponMessage(data.message || "Invalid coupon code.");
      }
    } catch (error) {
      console.error("Error applying coupon:", error);
      toast.error("Something went wrong. Try again.");
      setCouponMessage("Something went wrong. Try again.");
    }
  };

  const handlePayment = useCallback(async (price, applyWallet, walletused, discountAmount, couponCode, isGiftCodeApplied, giftCode) => {
    // Case: Full payment via wallet

    const responseApi = await instance.get('checkout');
    const carts = responseApi?.data?.carts ?? [];


    const invalidItem = carts?.find((item) => {
      const cartQty = Number(item?.quantity ?? 0);
      const stockQty = Number(item?.product?.quantity ?? 0);

      return cartQty > stockQty;
    });

    if (invalidItem) {
      const stockQty = Number(invalidItem?.product?.quantity ?? 0);

      toast.error(
        `${invalidItem?.product?.name ?? 'This item'} has insufficient stock (${stockQty} available)`
      );
      return;
    }





    if (price == 0 && applyWallet) {
      const walletBody = {
        order_from: "web",
        address_id: addressWalletId,
        payment_method: "wallet",
        transaction_status: "success",
        transaction_id: "",
        grand_amount: "0.00",
        wallets: walletused
      };

      if (walletused > 0) walletBody.wallet = walletused;
      if (discountAmount > 0) walletBody.discount = discountAmount;
      if (couponCode?.trim()) walletBody.coupon_code = couponCode.trim();

      try {
        const res = await postTranscationSave(walletBody, token);
        if (res?.error) return toast.error(res.error ?? "Something went wrong!");
        // dispatch(setCount(0));
        toast.success("Payment successful");
        router("/user/myorders");
        setShowRazorpayModal(false);
        return;
      } catch (err) {
        console.error(err);
        toast.error("Transaction failed");
        return;
      }
    }

    // Case: Razorpay payment
    const options = {
      key: RAZAR_KEY,
      amount: Math.round(price * 100),
      currency: "INR",
      name: "Greenheap",
      description: "Greenheap",
      image: "/assets/iocns/__Fav Icon.png",
      handler: async (res) => {
        const transactionId = res.razorpay_payment_id;



        // if (walletUsedAmount > 0) walletBody.wallet = walletUsedAmount;
        // if (discountAmount > 0) walletBody.discount = discountAmount;
        // if (couponCode?.trim()) walletBody.coupon_code = couponCode.trim();

        const body = {
          amount: price,
          transaction_id: transactionId,
          payment_method: "razor_pay",
          transaction_status: "success",
          wallets: walletused,
        };

        if (isGiftCodeApplied) {
          body.redeem_coupon_status = "1";
          body.redeem_coupon = giftCode;
        }

        // console.log(discountAmount, couponCode, "testing...")

        if (Number(discountAmount) > 0) {
          body.discount = Number(discountAmount);
        }

        if (couponCode?.trim()) {
          body.coupon_code = couponCode.trim();
        }

        try {
          const resTransaction = await postTranscationSave(body, token);

          if (resTransaction?.error) {
            return toast.error(resTransaction.error ?? "Something went wrong!");
          }


          dispatch(setCount(0));
          const closeBtn = document.querySelector("#giftCodeModal .btn-close");
          if (closeBtn) closeBtn.click();

          setTimeout(() => {
            document.querySelectorAll(".modal-backdrop").forEach(el => el.remove());
            document.body.classList.remove("modal-open");
            document.body.style.removeProperty("overflow");
            document.body.style.removeProperty("padding-right");
          }, 200);
          router("/user/myorders");
          toast.success("Payment successful");
          setShowRazorpayModal(false);

          const resBody = { paymentId: transactionId, amount: price };
          await capture_payment(resBody);

          // console.log("Payment captured successfully");
        } catch (err) {
          console.error("Payment processing error:", err);
          toast.error("Payment failed");
        }
      },
      theme: { color: "#650020" },
      // payment: {
      //   capture: "automatic",
      //   capture_options: {
      //     automatic_expiry_period: 12,
      //     manual_expiry_period: 7200,
      //     refund_speed: "optimum",
      //   },
      // },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();

    rzpay.on("payment.failed", function (response) {
      setShowRazorpayModal(false);
      console.error(response.error.description);
      toast.error(response.error.description);
    });
  }, [
    price, shemData, clientamount
  ]);

  // const handleApplyCoupon = async () => {
  //   if (applywallet && Number(clientamount) === 0) {
  //     toast.error("Coupon not applicable when wallet covers the full amount.");
  //     return;
  //   }
  //   if (!couponCode.trim()) {
  //     setCouponMessage("Please enter a coupon code.");
  //     return;
  //   }
  //   try {
  //     const response = await instance.get("/add_coupon", {
  //       params: {
  //         coupon_code: couponCode.trim(),
  //       },
  //     });
  //     // console.log("response", response);
  //     // GetCheckoutList();
  //     if (response.data.message == "Coupon Applied") {
  //       setCouponMessage("Coupon Applied successfully!");
  //     } else {
  //       setCouponMessage(response.data.message)
  //       // setCouponMessage("Invalid coupon code.");
  //     }
  //   } catch (error) {
  //     console.error("Error applying coupon:", error);
  //     setCouponMessage("Something went wrong. Try again.");
  //   }
  // };

  const handleRemoveCoupon = async () => {
    if (!couponCode.trim()) {
      toast.error("No coupon to remove.");
      return;
    }
    // setCouponCode("")

    try {
      const response = await instance.get("/remove_coupon_code", {
        params: { coupon_code: couponCode.trim() },
      });

      if (response.data.message === "Coupon Removed") {
        setCouponCode("");
        setCouponApplied(false);
        setDiscountAmount(0);
        setDiscountType("");

        setCouponInfo(null);
        setCouponMessage("Coupon removed successfully!");
        toast.success("Coupon removed successfully!");

        // 🔄 Recalculate totals without discount
        calculateTotals(0);
      } else {
        toast.error(response.data.message || "Invalid coupon code.");
        setCouponMessage(response.data.message || "Invalid coupon code.");
      }
    } catch (error) {
      console.error("Error removing coupon:", error);
      toast.error("Something went wrong. Try again.");
      setCouponMessage("Something went wrong. Try again.");
    }
  };
  const upiId = "Vyapar.171813426519@hdfcbank";
  const phonumber = setting_data ? setting_data[0]?.phone : "8190059995"
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [copiedField, setCopiedField] = useState("");

  const handleCopy = (text, fieldKey) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedField(fieldKey); // mark this field as copied
        // toast.success("Copied"); // show toast
        setTimeout(() => setCopiedField(""), 2000);
        setOpenSnackbar(true); /// reset after 2s
      })
      .catch((err) => console.error("Copy failed:", err));
  };

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };
  const [showModal, setShowModal] = useState(false);
  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  // const handleWalletPayment = (e) => {
  //   const checked = e.target.checked;
  //   setApplyWallet(checked);

  //   setclientamount((prev) => {
  //     if (checked) {
  //       const newAmount = prev - walletAmount;
  //       return newAmount > 0 ? newAmount : 0;
  //     } else {
  //       return prev + walletAmount > clientamount ? clientamount : prev + walletAmount;
  //     }
  //   });
  // };


  const handleWallet = (e) => {
    const checked = e.target.checked;
    // console.log(walletApivalue)

    if (!walletApivalue || walletApivalue <= 0) {
      toast.error("You don’t have sufficient wallet balance to use this option.")
      setApplyWallet(false);
      return
    }


    setApplyWallet(checked);

    let subtotal = Number(totapricedata?.total) || 0;
    let gst = Number(totapricedata?.gst) || 0;
    let shipping = Number(totapricedata?.shipping_cost) || 0;
    let discount = Number(discountAmount) || 0;

    let orderAmount = subtotal + gst + shipping - discount;
    if (orderAmount < 0) orderAmount = 0;

    let walletBalance = Number(walletAmount) || 0;
    let usedWallet = 0;
    let remaining = walletBalance;
    let payable = orderAmount;

    if (checked) {
      if (walletBalance >= orderAmount) {
        usedWallet = orderAmount;
        payable = 0;
        remaining = walletBalance - orderAmount;
      } else {
        usedWallet = walletBalance;
        payable = orderAmount - walletBalance;
        remaining = 0;
      }
    }

    orderAmount = Number(orderAmount.toFixed(2));
    usedWallet = Number(usedWallet.toFixed(2));
    remaining = Number(remaining.toFixed(2));
    payable = Number(payable.toFixed(2));
    subtotal = Number(subtotal.toFixed(2));
    gst = Number(gst.toFixed(2));
    shipping = Number(shipping.toFixed(2));
    discount = Number(discount.toFixed(2));
    walletBalance = Number(walletBalance.toFixed(2));

    setWalletUsedAmount(usedWallet);
    setRemainingWallet(remaining);
    setFinalPrice(payable);
    setGrandTotalAmount(payable);

    // console.log("===== 💰 WALLET CALCULATION =====");
    // console.log("Wallet Balance   :", walletBalance);
    // console.log("Discount Applied :", discount);
    // console.log("Order Amount     :", orderAmount);
    // console.log("Used Wallet      :", usedWallet);
    // console.log("Remaining Wallet :", remaining);
    // console.log("Payable Amount   :", payable);
    // console.log("=================================");
  };

  //for gift code added
  const [giftCode, setGiftCode] = useState();
  const [isGiftCodeApplied, setIsGiftCodeApplied] = useState(false)
  const [giftAmount, setGiftAmount] = useState()
  const finalPayableAfterGift = (
    finalPrice - (isGiftCodeApplied ? giftAmount : 0)
  ).toFixed(2);

  // const handleGiftApply = () => {
  //   if (!giftCode) {
  //     toast.error("Enter a Valid Gift Code")
  //     return;
  //   }
  //   console.log("clicked")
  //   apply_coupon(giftCode)
  //     .then((res) => {
  //       setGiftAmount(res?.data.amount)
  //       toast.success(res?.message)
  //       setIsGiftCodeApplied(true)
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //       setIsGiftCodeApplied(false)
  //     })
  // }

  const handleGiftApply = () => {
    if (!giftCode) {
      toast.error("Enter a valid gift code");
      return;
    }

    apply_coupon(giftCode)
      .then((res) => {
        if (res.result === true) {
          const voucherValue = res?.data?.amount || 0;
          if (parseInt(voucherValue) > parseInt(finalPrice)) {
            toast.error("Voucher value exceeds payable amount");
            // console.log("voucher amount", res?.data?.amount , "final value" , finalPrice)
            setIsGiftCodeApplied(false);
            return;
          }

          toast.success(res?.message || "Gift code applied successfully!");
          setGiftAmount(voucherValue);
          setIsGiftCodeApplied(true);
        } else {
          toast.error(res?.message || "Invalid coupon code!");
          setIsGiftCodeApplied(false);
        }
      })
      .catch((err) => {
        toast.error("Something went wrong. Please try again.");
        setIsGiftCodeApplied(false);
      });
  };

  const handleGiftRemove = () => {
    setGiftCode("");
    setGiftAmount(0);
    setIsGiftCodeApplied(false);
    toast.success("Gift code removed");
    document.getElementById("giftCodeInput").value = "";
  };

  return (
    <div className="container mt-5 mb-5 pt-3">
      <section>
        <div className="container mt-5 " data-aos="f">
          <div className="row">
            <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12 mt-3">
              <div className="d-flex justify-content-center contact-form2">
                <form onSubmit={Formik.handleSubmit} className="">
                  <div className="row">
                    <h6
                      style={{
                        color: "#972734",
                        fontWeight: "bold",
                      }}
                      className="mb-3 text-center"
                    >
                      <b>DELIVERY DETAILS</b>
                    </h6>
                    <hr />
                    <div className="accordion border-0" id="addressAccordion">
                      <div className="accordion-item border-0">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className={`accordion-button p-2 fs-6 ${!isAccordionOpen ? "collapsed" : ""
                              }`} // Apply collapsed class if accordion is closed
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded={isAccordionOpen ? "true" : "false"}
                            aria-controls="collapseOne"
                            style={{ maxWidth: "526px", width: "100%" }}
                          >
                            <b>Delivery Address</b>{" "}
                            <span className="text-danger ms-2">
                              <b>*</b>
                            </span>
                          </button>
                        </h2>

                        <div
                          id="collapseOne"
                          className={`accordion-collapse collapse ${isAccordionOpen ? "show" : ""
                            }`}
                          aria-labelledby="headingOne"
                          data-bs-parent="#addressAccordion"
                        >
                          <div className="accordion-body p-2">
                            <div className="form-group col-md-12 col-sm-12 col-12 login-text">
                              {AddressList.map((option) => {

                                const label = `${option.address_line_1 || ""}, ${option.address_line_2 || ""
                                  } ${option.citys?.city || ""}, ${option.states?.state || ""
                                  }, ${option.countrys?.name || ""} - ${option.postal_code || ""
                                  }`;

                                return (
                                  <div
                                    className="form-check position-relative"
                                    key={option.id}>

                                    <input
                                      className="form-check-input form-checkinput2"
                                      type="radio"
                                      id={`address-${option.id}`}
                                      name="address"
                                      value={option.id} // store ID in value
                                      onChange={() =>
                                        handleAddressChange(option.id, label)

                                      } // Pass addressId and label
                                      onBlur={Formik.handleBlur}
                                      checked={
                                        // Formik.values.address == option.id ||
                                        Formik.values.address == option.id

                                        // option.set_default == 1
                                      } // Check if the selected address matches Formik's value
                                    />

                                    <label
                                      className="form-check-label mt-1"
                                      htmlFor={`address-${option.id}`}
                                    >
                                      <div className="d-flex align-items-center formobile">
                                        <p
                                          className="ms-3 ajustfont mb-0"
                                          style={{ flex: 1 }}
                                        >
                                          <b>{label}</b>
                                        </p>
                                      </div>
                                    </label>

                                    <div className="position-absolute top-50 end-0 translate-middle-y d-flex flex-column align-items-center">
                                      <div className="d-flex">
                                        {/* <FaEdit
                                          className="text-primary mb-2"
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "18px",
                                            marginLeft: "10px",
                                            marginRight: "10px",
                                          }} // Set the same fixed size for Delete icon
                                          onClick={() =>
                                            handleEditAddress(option.id)
                                          }
                                        /> */}

                                        {/* <FaTrashAlt
                                          className=""
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "18px",
                                            marginLeft: "10px",
                                            marginRight: "10px",
                                            color: "#650020",
                                          }} // Set the same fixed size for Delete icon
                                          onClick={() =>
                                            handleDeleteAddress(option.id)
                                          }
                                        /> */}
                                      </div>
                                    </div>

                                  </div>
                                );
                              })}

                              {Formik.touched.address &&
                                Formik.errors.address ? (
                                <p className="text-danger">
                                  {Formik.errors.address}
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {selectedLabel && (
                    <div className=" selected-address">
                      <b>{selectedLabel}</b>
                    </div>
                  )}

                  <div className="form-group d-flex justify-content-end">
                    <div onClick={() => handleClick("user")}>
                      <div className="btn " style={{ backgroundColor: "brown" }}>
                        <b>
                          <i className="fa fa-plus-circle color"></i>{" "}
                        </b>{" "}
                        <b className="fontsmall text-light">Add Address</b>
                      </div>
                    </div>
                  </div>

                  {/* <div className="d-flex justify-content-end">
                    <button className="text-white" type="submit">
                      {spinner ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        ></span>
                      ) : (
                        <b>
                          Proceed to Checkout{" "}
                          <span className="ms-2">₹ {clientamount}</span>{" "}
                        </b>
                      )}
                    </button>
                  </div> */}
                </form>
              </div>

              <div className="d-flex justify-content-center contact-form2  mt-4">
                <form onSubmit={Formik.handleSubmit} className="">
                  <div className="row">
                    <h6
                      style={{
                        color: "#972734",
                        fontWeight: "bold",
                      }}
                      className="mb-3 text-center"
                    >
                      <b>Payment Type</b>
                    </h6>
                    <hr />

                    <div className="">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h1
                            className="modal-title fs-5 schemename"
                            id="razarpaypopupLabel"
                          >
                            {shemData?.plan_title === "digital_plan"
                              ? `${shemData?.name}(Cash Back)`
                              : shemData?.plan_title === "gold_plant"
                                ? `${shemData?.name}(Monthly Rental)`
                                : shemData?.name}
                          </h1>
                        </div>
                        <div className="modal-body">
                          <div className="pm-choice ">
                            <div
                              className={
                                process_type == "1"
                                  ? "form-check act"
                                  : "form-check"
                              }>
                              <div className="selecttypes p-2 d-flex align-items-center gap-2">
                                {/* <input
                          className="form-check-input mb-1"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio1"
                          value="1"

                          onChange={(e) => {
                            setprocess_type(e.target.value);
                          }}
                        /> */}
                                <input
                                  className="form-check-input mb-1"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  id="inlineRadio1"
                                  value="1"
                                  checked={process_type === "1"} // Set the checked attribute based on state
                                  onChange={(e) =>
                                    setprocess_type(e.target.value)
                                  } // Update state on change
                                />

                                <label className="form-check-label" htmlFor="inlineRadio1">
                                  <div className="razoricon">
                                    <img
                                      src="\assets\images\visa.png"
                                      className="img-fluid"
                                      alt=""
                                    />
                                    <img
                                      src="\assets\images\mascard.png"
                                      className="img-fluid"
                                      alt=""
                                    />
                                    <img
                                      src="\assets\images\rupay.png"
                                      className="img-fluid"
                                      alt=""
                                    />
                                    <img
                                      src="\assets\images\phopay.png"
                                      className="img-fluid"
                                      alt=""
                                    />
                                    <img
                                      src="\assets\images\mastro.png"
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </div>
                                </label>


                              </div>
                            </div>
                            {/* <div
                      className={
                        process_type == "2" ? "form-check act" : "form-check"
                      }
                    >
                      <div className="selecttypes p-2  d-flex align-items-center gap-2">
                        <input
                          className="form-check-input  mb-1"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio2"
                          value="2"
                          onChange={(e) => {
                            setprocess_type(e.target.value);
                          }}
                        />

                        <label className="form-check-label" htmlFor="inlineRadio2">
                          Direct UPI Payments (QR Code){" "}
                        </label>
                        <div className="razoricon">
                          <img
                            src="\assets\images\upis.png"
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </div>
                    </div> */}
                            {/* <div
                      className={
                        process_type == "3" ? "form-check act" : "form-check"
                      }
                    >
                      <div className="selecttypes py-3 px-2  d-flex align-items-center gap-2">
                        <input
                          className="form-check-input  mb-1"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio3"
                          value="3"
                          onChange={(e) => {
                            setprocess_type(e.target.value);
                          }}
                        />

                        <label className="form-check-label" htmlFor="inlineRadio3">
                          For RTGS / NEFT / IMPS
                        </label>
                        <div className="banic">
                          <img
                            src="assets\images\net_img.png"
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </div>
                    </div> */}
                            {/* <div className="update-profile ">
                      <button className="text-white" type="submit">
                        Continue
                      </button>
                    </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12 mt-3">
              <div className="d-flex justify-content-center contact-form2">
                <form className="">
                  <div className="row">
                    <h6
                      style={{
                        color: "#972734",
                        fontWeight: "bold",
                      }}
                      className="mb-3 text-center"
                    >
                      <b>Order Summary</b>
                    </h6>
                    <hr />

                    {/* <div className="product-grid mb-3 mt-3">
                      {cartdata?.map((item) => (
                        <div key={item.id} className="product-card">
                          <img
                            src={item?.first_image_url}
                            alt={item.name}
                            className="product-image"
                          />
                          <div className="product-info">

                            <p className="product-price"> ₹ {item.price}</p>
                          </div>
                        </div>
                      ))}
                    </div>
   Loader
                      <div className="text-center my-5">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
                    */}

                    {isloading ? (
                      <div className="product-grid mb-3 mt-3">
                        {sampleImageWithNamePrice?.length > 0 ? (
                          sampleImageWithNamePrice.map((item) => (
                            <div key={item.id} className="product-card">
                              <div className="product-info"></div>
                            </div>
                          ))
                        ) : (
                          <p className="text-center">Your cart is empty.</p>
                        )}
                      </div>
                    ) : (
                      // <div className="product-grid mb-3 mt-3">
                      //   {cartdata?.length > 0 ? (
                      //     cartdata.map((item) => (
                      //       <div key={item.id} className="product-card">
                      //         <img
                      //           src={item?.product?.images?.[0]?.image}
                      //           alt={item.name}
                      //           className="product-image"
                      //         />
                      //         <div className="product-info">
                      //           {/* <p className="product-name hidemanbyelp">
                      //         {item.name}
                      //       </p> */}
                      //           <p className="product-price">₹ {item.price}</p>
                      //         </div>
                      //       </div>
                      //     ))
                      //   ) : (
                      //     <p className="text-center">Your cart is empty.</p>
                      //   )}
                      // </div>
                      <div className="product-grid mb-3 mt-3">
                        {cartdata?.length > 0 ? (
                          cartdata.map((item) => (
                            <div key={item.id} className="product-card">
                              {item?.product?.images?.[0]?.image ? (
                                <img
                                  src={item.product.images[0].image}
                                  alt={item.name}
                                  className="product-image"
                                />
                              ) : (
                                <div className="no-image-text">No image found</div>
                              )}
                              <div className="product-info">
                                <p className="product-price">₹ {item.price}</p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p className="text-center">Your cart is empty.</p>
                        )}
                      </div>

                    )}

                    <hr />

                    {totapricedata ? (
                      <div className=" ">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <p>
                            <b>Total</b>
                          </p>
                          {/* <p>
                            <b>₹ {totapricedata?.total}</b>
                          </p> */}
                          <p>
                            <b>  {Number(totapricedata?.before_total).toLocaleString('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            })}</b>
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <p>
                            <b>
                              GST
                              {totapricedata?.tax
                                ? ` (${totapricedata.tax}%)`
                                : ""}
                            </b>

                          </p>
                          {/* <p>
                            <b>(+) ₹ {totapricedata?.gst}</b>
                          </p> */}
                          <p>
                            <b>  {Number(totapricedata?.gst).toLocaleString('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            })}</b>
                          </p>

                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <p>
                            <b>ShippingCost</b>
                          </p>
                          <p>
                            <b>(+) ₹ {totapricedata?.shipping_cost}</b>
                          </p>
                        </div>
                        {/* <div className="d-flex justify-content-between align-items-center mb-2">
                          <p>
                            <b>wallet</b>
                          </p>
                          <p>
                            <b>(-)₹ {totapricedata?.wallet}</b>
                          </p>
                        </div> */}

                        {totapricedata?.special_discount > 0 && (
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <p>
                              <b>Special Discount</b>
                            </p>
                            <p>
                              <b className="text-success">(-) ₹ {Math.round(totapricedata?.special_discount)}</b>
                            </p>
                          </div>
                        )}
                        {couponApplied && (
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <p>
                              <b>Discount Price </b>
                            </p>
                            {/* <p>
                            <b>₹ {totapricedata?.grand_total}</b>
                          </p> */}
                            <p>
                              {/* {discountType === "amount"
                                  ? `₹${discountAmount} `
                                  : `${discountAmount} (% `} */}

                              <b className="text-danger">
                                {discountType === "amount"
                                  ? `- ${Number(discountAmount).toLocaleString("en-IN", {
                                    style: "currency",
                                    currency: "INR",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,

                                  })}`
                                  : `- ${discountAmount} (%)`}
                              </b>
                            </p>

                          </div>
                        )}

                        {/* <div className="d-flex justify-content-between align-items-center mb-2">
                          <p>
                            <b>Grand Total </b>
                          </p>
                          {/* <p>
                            <b>₹ {totapricedata?.grand_total}</b>
                          </p> */}
                        {/* <p>
                          <b>  {Number(applywallet
                            // ? Math.max(totapricedata?.grand_total - walletAmount, 0)
                            // : totapricedata?.grand_total
                            ? totapricedata?.grand_total - walletAmount : totapricedata?.grand_total
                          ).toLocaleString('en-IN', {
                            style: 'currency',
                            currency: 'INR',
                            minimumFractionDigits: 2,
                          })}</b>
                        </p> */}

                        {/* </div>  */}
                      </div>
                    ) : (
                      <>
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex align-items-center justify-content-center">
                          <img
                            src="/assets/noData.png"
                            alt="No Data"
                            width={160}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  {totapricedata?.coupon.length > 0 && (
                    <>
                      {/* <div className="d-flex">
                        <p>
                          <b>Coupon Codes :</b>
                        </p>

                        {totapricedata?.coupon?.map((coupon, index) => (
                          <div key={coupon.id || index}>
                            <span
                              className="ms-3"
                              style={{
                                color: "#972734",
                                fontWeight: "bold",
                                fontSize: "15px",
                              }}
                            >
                              {coupon.code}
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className="form-group col-11 login-text d-flex justify-content-between ">
                        <input
                          type="text"
                          className="form-control"
                          id="inputfirtname"
                          placeholder="Enter Coupon"
                          value={couponCode}
                          onChange={(e) => setCouponCode(e.target.value)}
                        />

                        {isCouponApplied === true ? (
                          <div
                            className="buttondesign ms-2   align-items-center "
                            onClick={handleRemoveCoupon}
                            style={{ cursor: "pointer" }}
                          >
                            <b>Remove</b>
                          </div>
                        ) : (
                          <div
                            className="buttondesign ms-2   align-items-center "
                            onClick={handleApplyCoupon}
                            style={{ cursor: "pointer" }}
                          >
                            <b>Apply</b>
                          </div>
                        )}
                      </div> */}
                      <div className="d-flex flex-wrap align-items-center justify-content-between mb-2">
                        <p className="mb-0">
                          <b>Coupon Codes :</b>
                        </p>


                        {/* <Select
                          options={totapricedata?.coupon?.map((coupon) => ({
                            value: coupon.code,
                            label: `${coupon.code} — ${coupon.discount_type === "amount"
                              ? `₹${coupon.discount} OFF`
                              : `${coupon.discount}% OFF`
                              }`,
                          })) || []}
                          value={
                            totapricedata?.coupon_code
                              ? {
                                value: totapricedata.coupon_code,
                                label: totapricedata.coupon_code,
                              }
                              : null
                          }
                          placeholder="Select Coupon"
                          onChange={(selected) => {
                            const code = selected?.value || "";
                            handleCouponSelect(code);
                            setCouponCode(code);
                          }}
                          styles={{
                            control: (base) => ({
                              ...base,
                              width: "200px",   // 👈 fixed width
                              minWidth: "150px", // optional, ensures it doesn't shrink below this
                            }),
                            menu: (base) => ({
                              ...base,
                              maxWidth: "150px",
                              maxHeight: "200px",
                              overflowY: "auto",
                            }),
                          }} */}
                        <Select
                          options={totapricedata?.coupon?.map((coupon) => ({
                            value: coupon.code,
                            label: `${coupon.code} — ${coupon.discount_type === "amount"
                              ? `₹${coupon.discount} OFF`
                              : `${coupon.discount}% OFF`
                              }`,
                          })) || []}
                          value={
                            totapricedata?.coupon_code
                              ? {
                                value: totapricedata.coupon_code,
                                label: totapricedata.coupon_code,
                              }
                              : null
                          }
                          placeholder="Select Coupon"
                          onChange={(selected) => {
                            const code = selected?.value || "";
                            handleCouponSelect(code);
                            setCouponCode(code);
                          }}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minWidth: "200px",
                              width: "200px",
                            }),
                            menu: (base) => ({
                              ...base,
                              maxHeight: "200px",
                              overflowY: "auto",
                              width: "200px",
                            }),
                            menuList: (base) => ({
                              ...base,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }),
                          }}

                        />

                        {/* <select
                          className="form-select ms-3 mb-2"
                          style={{
                            width: "auto",
                            display: "inline-block",
                            maxHeight: "50px",      
                            overflowY: "scroll",      
                          }}
                          // style={{ width: "auto", display: "inline-block" }}
                          value={totapricedata?.coupon_code || ""}
                          onChange={(e) => {
                            const selectedCode = e.target.value;
                          
                            handleCouponSelect(selectedCode);
                            setCouponCode(selectedCode)
                          }}
                        >
                          <option value="">Select Coupon</option>

                          {totapricedata?.coupon?.map((coupon, index) => (
                            <option key={coupon.id || index} value={coupon.code}>
                              {coupon.code} —{" "}
                              {coupon.discount_type === "amount"
                                ? `₹${coupon.discount} OFF`
                                : `${coupon.discount}% OFF`}
                            </option>
                          ))}
                        </select> */}

                        {/* {totapricedata?.coupon?.map((coupon, index) => (
                          <div key={coupon.id || index} >
                            <span
                              className={`ms-3 mb-2 badge ${totapricedata?.coupon_code &&
                                coupon?.code &&
                                String(totapricedata.coupon_code).trim() === String(coupon.code).trim()
                                ? "bg-danger text-light"
                                : "bg-light text-dark"
                                }`}
                              // className={`ms-3 mb-2 badge ${totapricedata?.coupon_code === coupon?.code  ? "bg-danger text-light" : "bg-light text-dark"}`}
                              style={{
                                color: "#972734",
                                // color:" #991313",
                                fontWeight: "bold",
                                fontSize: "14px",
                                wordBreak: "break-word",
                              }}
                            >
                              {coupon.code}

                              <br />
                              <small className="text-danger mt-2">
                                {coupon?.discount_type === "amount"
                                  ? `₹${coupon.discount} OFF`
                                  : `${coupon.discount}% OFF`}
                              </small>

                            </span>

                          </div>
                        ))} */}
                      </div>



                      <div className="form-group col-12 login-text d-flex flex-wrap justify-content-between gap-2">
                        <input
                          type="text"
                          className="form-control flex-grow-1"
                          id="inputfirtname"
                          placeholder="Enter Coupon"
                          disabled={couponApplied}
                          value={couponCode || ""}
                          onChange={(e) => setCouponCode(e.target.value)}
                        />


                        <div
                          className="buttondesign ms-2 align-items-center d-flex"
                          onClick={couponApplied ? () => handleRemoveCoupon(couponCode || totapricedata?.coupon_code) : handleApplyCoupon}
                          style={{
                            cursor: "pointer",
                            padding: "6px 12px",
                            whiteSpace: "nowrap",
                          }}
                        >

                          <b>{couponApplied ? "Remove" : "Apply"}</b>
                        </div>

                      </div>

                    </>
                  )}

                  {couponMessage && (
                    <p className="text-success mt-2">{couponMessage}</p>
                  )}


                  {totapricedata ? (

                    <div className="d-flex justify-content-start align-items-center wallet-form  mt-4 mb-2">





                      {/* <input
                      className="form-check-input  me-2"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="2"
                      onChange={(e) => {
                        setprocess_type(e.target.value);
                      }}
                    /> */}
                      {
                        // detail_info?.role == 1
                        <div className=" mt-2 mb-3 mb-2">
                          <div className="ps-3 pt-2 pb-1 d-flex gap-2 align-items-center">
                            <input
                              type="checkbox"
                              value={applyWallet}
                              disabled={walletAmount == "0"}
                              // onChange={(e) => setApplyWallet(e.target.checked)}
                              onClick={handleWallet}
                              id="walletApply"
                            />
                            <h6
                              className="fs-6 mb-0 pb-0"
                              onClick={() =>
                                document.getElementById("walletApply")?.click()
                              }
                            >
                              <b> Apply Wallet : ₹ {walletAmount || "0"} </b>
                            </h6>
                          </div>
                          {applyWallet && (
                            <small className="ps-3 pt-2 pb-1 text-success">
                              Remaining Amount in Wallet : ₹{" "}
                              {remainingWallet}
                              {/* {Math.max(remaining - totapricedata?.grand_total, 0)} */}
                            </small>
                          )}



                          {/* <small className="ps-3 pt-2 pb-1 text-success">Remaining Amount in Wallet : ₹ {applywallet ? walletAmount - clientamount > 0 ? walletAmount - clientamount : 0 : walletAmount}</small> */}
                        </div>}


                    </div>


                  ) : " "}

                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <p>
                      <b>Grand Total</b>
                    </p>
                    <p>
                      <b> {Number(finalPrice).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                        minimumFractionDigits: 2,
                      })}</b>
                    </p>
                  </div>





                  {totapricedata?.grand_total === 0 ? (
                    <></>
                  ) : (
                    totapricedata?.grand_total && (
                      <div className="d-flex justify-content-end">
                        {/* <button className="text-white" type="button"
                         onClick={() => handlePayment(finalPrice, applyWallet, walletUsedAmount, discountAmount, couponCode)}
                        >
                          {spinner ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                            ></span>
                          ) : (
                            <b>
                              Proceed to Checkout{" "}
                              <span className="ms-2">
                                ₹ {finalPrice ? finalPrice : "0"}
                              </span>{" "}
                            </b>
                          )}
                        </button>
                         */}
                        {finalPrice === 0 ? (

                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>
                              handlePayment(
                                finalPrice,
                                applyWallet,
                                walletUsedAmount,
                                discountAmount,
                                couponCode
                              )
                            }
                          >
                            Continue to Payment ₹{finalPrice}
                          </button>
                        ) : (
                          <button
                            style={{ backgroundColor: "brown" }}
                            type="button"
                            className="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#giftCodeModal"
                          >
                            Continue
                          </button>
                        )}


                      </div>
                    )
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* payment-modal */}

      <section>
        <button
          type="button"
          className="btn btn-primary d-none"
          data-toggle="modal"
          data-target="#paymentbox"
          id="payment-pup"
        >
          Launch demo modal
        </button>
        <div
          className="modal fade"
          id="paymentbox"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1
                  className="modal-title fs-5 schemename"
                  id="razarpaypopupLabel"
                >
                  {shemData?.plan_title === "digital_plan"
                    ? `${shemData?.name}(Cash Back)`
                    : shemData?.plan_title === "gold_plant"
                      ? `${shemData?.name}(Monthly Rental)`
                      : shemData?.name}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    document.getElementById("payment-pup").click();
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <div className="pm-ti">
                  <h5> Choose Payment Method</h5>
                </div>
                <div className="pm-choice ">
                  <form onSubmit={paymentfun}>
                    <div
                      className={
                        process_type == "2" ? "form-check act" : "form-check"
                      }
                    >
                      <div className="selecttypes p-2  d-flex align-items-center gap-2">
                        <input
                          className="form-check-input  mb-1"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio2"
                          value="2"
                          onChange={(e) => {
                            setprocess_type(e.target.value);
                          }}
                        />
                        {/* <label className="form-check-label" htmlFor="inlineRadio2">QR code / UPI</label> */}
                        <label className="form-check-label" htmlFor="inlineRadio2">
                          Direct UPI Payments (QR Code){" "}
                        </label>
                        <div className="razoricon">
                          <img
                            src="\assets\images\upis.png"
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        process_type == "1" ? "form-check act" : "form-check"
                      }
                    >
                      <div className="selecttypes p-2 d-flex align-items-center gap-2">
                        <input
                          className="form-check-input mb-1"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio1"
                          value="1"
                          onChange={(e) => {
                            setprocess_type(e.target.value);
                          }}
                        />
                        <label className="form-check-label" htmlFor="inlineRadio1">
                          <div className="razoricon">
                            <img
                              src="\assets\images\visa.png"
                              className="img-fluid"
                              alt=""
                            />
                            <img
                              src="\assets\images\mascard.png"
                              className="img-fluid"
                              alt=""
                            />
                            <img
                              src="\assets\images\rupay.png"
                              className="img-fluid"
                              alt=""
                            />
                            <img
                              src="\assets\images\phopay.png"
                              className="img-fluid"
                              alt=""
                            />
                            <img
                              src="\assets\images\mastro.png"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </label>
                        {/* 
                        <div className="razoricon">
                          <img
                            src="\assets\images\visa.png"
                            className="img-fluid"
                            alt=""
                          />
                          <img
                            src="\assets\images\mascard.png"
                            className="img-fluid"
                            alt=""
                          />
                          <img
                            src="\assets\images\rupay.png"
                            className="img-fluid"
                            alt=""
                          />
                          <img
                            src="\assets\images\phopay.png"
                            className="img-fluid"
                            alt=""
                          />
                          <img
                            src="\assets\images\mastro.png"
                            className="img-fluid"
                            alt=""
                          />
                        </div> */}
                      </div>
                    </div>

                    <div
                      className={
                        process_type == "3" ? "form-check act" : "form-check"
                      }
                    >
                      <div className="selecttypes py-3 px-2  d-flex align-items-center gap-2">
                        <input
                          className="form-check-input  mb-1"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio3"
                          value="3"
                          onChange={(e) => {
                            setprocess_type(e.target.value);
                          }}
                        />
                        {/* <label className="form-check-label" htmlFor="inlineRadio3">Bank Details</label> */}
                        <label className="form-check-label" htmlFor="inlineRadio3">
                          For RTGS / NEFT / IMPS
                        </label>
                        <div className="banic">
                          <img
                            src="assets\images\net_img.png"
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div className="update-profile ">
                      <button className="text-white" type="submit">
                        Continue
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* qr-code-modal */}

      <section>
        <button
          type="button"
          className="btn btn-primary d-none"
          data-toggle="modal"
          data-target="#offlinebox"
          id="offlinepop-pup"
        >
          Launch demo modal
        </button>
        <div
          className="modal fade"
          id="offlinebox"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1
                  className="modal-title fs-5 schemename"
                  id="razarpaypopupLabel"
                >
                  <span
                    className="mx-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      document.getElementById("offlinepop-pup").click();
                      document.getElementById("payment-pup").click();
                    }}
                  >
                    <ArrowLeft />
                  </span>
                  {shemData?.plan_title === "digital_plan"
                    ? `${shemData?.name}(Cash Back)`
                    : shemData?.plan_title === "gold_plant"
                      ? `${shemData?.name}(Monthly Rental)`
                      : shemData?.name}
                </h1>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    document.getElementById("offlinepop-pup").click();
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <div className="d-flex mb-2 mt-2 justify-content-center align-items-center gap-1" >
                  <img src="/assets/images/g-pay.png" alt="gpay" height={70} />
                  <img src="/assets/images/phone-pe.png" alt="phonepay" height={50} />

                  <div className="d-flex text-center align-items-center qr-upiid justify-content-between ">
                    <button
                      className="btn btn-sm"
                      style={{ fontSize: "1rem" }}
                      onClick={() => handleCopy(phonumber, "phone")}
                    >
                      <FaCopy
                        className={`${copiedField === "phone" ? "text-dark" : "text-secondary"}`}
                      />
                    </button>
                    <h6 className="mb-0">{phonumber}</h6>


                    {/* <FaCopy className={`${copied ? "text-dark" : "text-secondary"} `}  onClick={() => handleCopy(upiId)} /> */}

                  </div>
                </div>
                <div className="qr-detail text-center">
                  <h6>{setting_data ? setting_data[0]?.account_holder : ""}</h6>
                </div>

                <div className='d-flex justify-content-center'>
                  <div className="qr-upiid text-center d-flex align-items-center ">
                    <button
                      className="btn btn-sm"
                      style={{ fontSize: "1rem" }}
                      onClick={() => handleCopy(upiId, "upi")}
                    >
                      <FaCopy
                        className={`${copiedField === "upi" ? "text-dark" : "text-secondary"}`}
                      />
                    </button>
                    <h6 className="mb-0">{upiId}</h6>

                    {/* <h6 className='mb-0'>Vyapar.171813426519@hdfcbank</h6> */}
                  </div>
                </div>

                <Snackbar
                  open={openSnackbar}
                  autoHideDuration={2000}
                  onClose={handleCloseSnackbar}
                  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                >
                  <Alert onClose={handleCloseSnackbar} sx={{ width: "100%" }}>
                    Copied to clipboard!
                  </Alert>
                </Snackbar>


                {/* <div className="d-flex justify-content-center">
                  <div className="qr-upiid text-center">
                    <h6 className="mb-0">Vyapar.171813426519@hdfcbank</h6>
                  </div>
                </div> */}


                <div className="qq-sacn-img p-2">
                  <img
                    src={setting_data ? setting_data[0]?.qr_code : ""}
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <form onSubmit={upimethod}>
                  <div className="uplo-img ">
                    <input
                      type="file"
                      className="d-none"
                      id="scanimg"
                      onChange={screenshot}
                    />
                    <button
                      className="btn"
                      type="button"
                      onClick={() => {
                        document.getElementById("scanimg").click();
                      }}
                    >
                      Upload Payment ID PHOTO/IMAGE HERE {" "}
                      <img
                        src="\assets\iocns\upload.png"
                        alt=""
                        className="img-fluid"
                      />
                    </button>
                    {!file1 && <span className="text-end d-block mt-2">
                      <div
                        className="d-flex align-items-center justify-content-end gap-2"
                        style={{ cursor: "pointer" }}
                        onClick={handleOpen}
                      >
                        <img
                          src="/assets/iocns/eye.png"
                          alt="preview"
                          className="text-danger"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <span className="text-secondary">Example Transaction Slip</span>
                      </div>
                    </span>}

                    {/* Bootstrap Modal */}
                    <Modal show={showModal} onHide={handleClose} centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Example Transaction Slip</Modal.Title>
                      </Modal.Header>
                      <Modal.Body className="text-center">
                        <img
                          src="/assets/images/example_slip.jfif"
                          alt="Preview"
                          style={{ maxWidth: "100%", maxHeight: "600px" }}
                        />
                      </Modal.Body>

                    </Modal>


                    {file1 ? (
                      <>
                        <div className="uploadfile-name position-relative">
                          <p className="m-0">
                            {file1 ? `File Name : ${file1}` : ""}
                          </p>
                          <h6
                            className="position-absolute remove-upload"
                            onClick={() => {
                              setfile1();
                              settransfile();
                            }}
                          >
                            <X />
                          </h6>
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    <input
                      type="text"
                      className="form-control bg-white text-dark border text-center my-2"
                      placeholder="SEND (or) PASTE SMS Transaction ID Here"
                      aria-label="transaction-id"
                      id="transaction-id"
                      onChange={(e) => {
                        setTranscationid(e.target.value);
                      }}
                    />
                    <p className="text-danger ">
                      * Upload the transaction slip or enter the transaction ID
                    </p>
                  </div>
                  <div className="update-profile">
                    <button className="text-white" type="submit">
                      {spinner ? (
                        <span
                          className="spinner-border spinner-border-sm "
                          role="status"
                        ></span>
                      ) : (
                        "Continue"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* bandetail-modal */}

      <section>
        <button
          type="button"
          className="btn btn-primary d-none"
          data-toggle="modal"
          data-target="#bankbox"
          id="bankpop-pup"
        >
          Launch demo modal
        </button>
        <div
          className="modal fade"
          id="bankbox"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1
                  className="modal-title fs-5 schemename"
                  id="razarpaypopupLabel"
                >
                  <span
                    className="mx-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      document.getElementById("bankpop-pup").click();
                      document.getElementById("payment-pup").click();
                    }}
                  >
                    <ArrowLeft />
                  </span>{" "}
                  {shemData?.plan_title === "digital_plan"
                    ? `${shemData?.name}(Cash Back)`
                    : shemData?.plan_title === "gold_plant"
                      ? `${shemData?.name}(Monthly Rental)`
                      : shemData?.name}{" "}
                </h1>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    document.getElementById("bankpop-pup").click();
                  }}
                ></button>
              </div>
              <div className="modal-body ac-holdbank">
                <h5 className="mb-4">Bank Details</h5>

                <div className="acc-holder">
                  <img
                    src="\assets\iocns\Profile.png"
                    className="img-fluid"
                    alt=""
                  />
                  <span>
                    Account Name : {setting_data ? setting_data[0]?.account_holder : ""}
                  </span>
                </div>
                <div className="acc-holder">
                  <img
                    src="\assets\iocns\accountnumber.png"
                    className="img-fluid"
                    alt=""
                  />
                  <span>
                    Account Number :
                    {setting_data ? setting_data[0]?.account_number : ""}
                  </span>
                </div>
                <div className="acc-holder">
                  <img
                    src="\assets\iocns\bank.png"
                    className="img-fluid"
                    alt=""
                  />
                  <span>Bank Name : {setting_data ? setting_data[0]?.bank_name : ""}</span>
                </div>
                <div className="acc-holder">
                  <img
                    src="\assets\iocns\branchlocatin.png"
                    className="img-fluid"
                    alt=""
                  />
                  <span>Branch Name :
                    {setting_data ? setting_data[0]?.branch_name : ""}
                  </span>
                </div>
                <div className="acc-holder">
                  <img
                    src="\assets\iocns\ifsc code.png"
                    className="img-fluid"
                    alt=""
                  />
                  <span>IFSC Code : {setting_data ? setting_data[0]?.ifsc_code : ""}</span>
                </div>
                <form onSubmit={Bankmethod}>
                  <div className="uplo-img text-start">
                    <input
                      type="file"
                      className="d-none"
                      id="scanimg"
                      onChange={screenshot}
                    />
                    <button
                      className="btn "
                      type="button"
                      onClick={() => {
                        document.getElementById("scanimg").click();
                      }}
                    >
                      Upload Payment ID PHOTO/IMAGE HERE {" "}
                      <img
                        src="\assets\iocns\upload.png"
                        alt=""
                        className="img-fluid"
                      />
                    </button>
                    {file1 ? (
                      <>
                        <div className="uploadfile-name position-relative">
                          <p className="m-0">
                            {file1 ? `File Name : ${file1}` : ""}
                          </p>
                          <h6
                            className="position-absolute remove-upload"
                            onClick={() => {
                              setfile1();
                              settransfile();
                            }}
                          >
                            <X />
                          </h6>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <input
                      type="text"
                      className="form-control bg-white text-dark border text-center my-2"
                      placeholder="SEND (or) PASTE SMS Transaction ID Here"
                      id="transaction-id2"
                      aria-label="transaction-id"
                      onChange={(e) => {
                        setTranscationid(e.target.value);
                      }}
                    />
                    <p className="text-danger ">
                      * Upload the transaction slip or enter the transaction ID
                    </p>
                  </div>

                  <div className="update-profile mt-2 mb-0">
                    <button className="text-white" type="submit">
                      {spinner ? (
                        <span
                          className="spinner-border spinner-border-sm "
                          role="status"
                        ></span>
                      ) : (
                        "Continue"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Gift code modal */}
      <div
        className="modal fade"
        id="giftCodeModal"
        tabIndex="-1"
        aria-labelledby="giftCodeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title" id="giftCodeModalLabel">Payment Options</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <div className="d-flex gap-2">
                <input
                  type="text"
                  className="form-control"
                  id="giftCodeInput"
                  placeholder="Enter gift code"
                  onChange={(e) => setGiftCode(e.target.value)}
                />
                {isGiftCodeApplied ? (
                  <button
                    className="btn btn-danger"
                    onClick={handleGiftRemove}
                  >
                    Remove
                  </button>
                ) : (
                  <button
                    className="btn btn-success"
                    onClick={handleGiftApply}
                  >
                    Apply
                  </button>
                )}

              </div>

              <h5 className="py-2 mt-1">Payment Summary</h5>

              <hr style={{ borderTop: "1px dashed #aaa" }} />

              <div className="d-flex justify-content-between align-items-center">
                <p>
                  <b>Amount</b>
                </p>
                <p>
                  <b> ₹ {finalPrice}</b>


                </p>
              </div>

              {isGiftCodeApplied && <div className="d-flex justify-content-between align-items-center">
                <p>
                  <b>Gift Amount</b>
                </p>
                <p>
                  <b> -₹ {giftAmount}</b>


                </p>
              </div>}

              <hr style={{ borderTop: "1px dashed #aaa" }} />


              <div className="d-flex justify-content-between align-items-center">
                <p>
                  <b>Final Payable</b>
                </p>
                <p>
                  <b>₹ {finalPayableAfterGift}</b>
                  {/* <b> ₹ {isGiftCodeApplied ? finalPrice- giftAmount : finalPrice}</b> */}
                </p>
              </div>


            </div>

            <div className="modal-footer">



              <button
                type="button"
                style={{ backgroundColor: "#650020" }}
                className="btn w-100 text-light border-10"
                // disabled={isGiftCodeApplied && giftAmount > finalPrice}
                onClick={() =>
                  handlePayment(
                    finalPayableAfterGift,
                    applyWallet,
                    walletUsedAmount,
                    discountAmount,
                    couponCode,
                    isGiftCodeApplied,
                    giftCode
                  )
                }
              >
                Continue to Payment
              </button>
            </div>

          </div>
        </div>
      </div>




    </div>
  );
};

export default CheckOutFormPage;
